import { createPinia } from 'pinia';

// Create Pinia instance
const pinia = createPinia();

// Auto-persist authentication state to localStorage
pinia.use(({ store }) => {
  if (store.$id === 'auth') {
    // Initialize from localStorage
    const stored = localStorage.getItem('pinia-auth');
    if (stored) {
      try {
        const data = JSON.parse(stored);
        store.$patch({
          userData: data.userData || null,
          token: data.token || '',
        });
      } catch (error) {
        console.error('Failed to restore auth state:', error);
      }
    }

    // Subscribe to state changes and persist
    store.$subscribe(
      (mutation, state) => {
        localStorage.setItem(
          'pinia-auth',
          JSON.stringify({
            userData: state.userData,
            token: state.token,
          })
        );
      },
      { detached: true }
    );
  } else if (store.$id === 'cart') {
    // Initialize from localStorage
    const stored = localStorage.getItem('pinia-cart');
    if (stored) {
      try {
        const data = JSON.parse(stored);
        store.$patch(data);
      } catch (error) {
        console.error('Failed to restore cart state:', error);
      }
    }

    // Subscribe to state changes and persist
    store.$subscribe(
      (mutation, state) => {
        localStorage.setItem('pinia-cart', JSON.stringify(state));
      },
      { detached: true }
    );
  }
});

export default pinia;
